import React from 'react';
import CandyLogo from './CandyLogo';

export default class FergusLogo extends React.Component {
    render() {
        return (
            <CandyLogo
                size={40}
                className={this.props.className}
                style={{verticalAlign: 'middle', margin: '0 8px 0 12px', ...this.props.style}} />
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/FergusLogo.js